/**
 * Routes drawn as a fixed overlay over the still-mounted tab shell rather than
 * replacing it — Hallouminati's guide chapter and the vocab tab's sub-pages
 * (products/hallouminati/index.tsx). The tab underneath is the page the user
 * returns to, so entering, leaving or paging through the overlay must neither
 * switch it (MainApp's URL → tab sync) nor scroll it (ScrollToTop) — and the
 * tabs behind it must not navigate away from it (useSetupRedirect).
 *
 * Contract: docs/hallouminati/vocab-trainer.md §Word lists (the vocab pages)
 */
const SHELL_OVERLAY_ROUTE = /^\/[^/]+\/(guide\/chapter|vocab)\//;

export function isShellOverlayRoute(pathname: string): boolean {
    return SHELL_OVERLAY_ROUTE.test(pathname);
}
